function initCommunesSelection(zoneSelector = ".select-zone", communeSelector = ".commune-checkbox") {
    const zoneChecks = document.querySelectorAll(zoneSelector);
    const communeCheckboxes = document.querySelectorAll(communeSelector);

    // Per-zone select/deselect
    zoneChecks.forEach(zcb => {
        zcb.addEventListener("change", e => {
            const zone = e.target.dataset.zone;
            document.querySelectorAll(`${communeSelector}.zone_${zone}`)
                .forEach(cb => cb.checked = e.target.checked);
        });
    });

    // Sync zone checkbox when individual communes change
    communeCheckboxes.forEach(cb => {
        cb.addEventListener("change", e => {
            const zoneClass = Array.from(e.target.classList)
                                    .find(c => c.startsWith("zone_"));
            if (!zoneClass) return;
            const zone = zoneClass.split("_")[1];
            const allInZone = document.querySelectorAll(`${communeSelector}.zone_${zone}`);
            const zoneCheckbox = document.querySelector(
                `${zoneSelector}[data-zone="${zone}"]`
            );
            if (!zoneCheckbox) return;
            zoneCheckbox.checked = Array.from(allInZone).every(c => c.checked);
        });
    });

    // ——— Synchronisation initiale au chargement de la page ———
    zoneChecks.forEach(zcb => {
        const zone = zcb.dataset.zone;
        const allInZone = document.querySelectorAll(`${communeSelector}.zone_${zone}`);
        if (allInZone.length > 0) {
            zcb.checked = Array.from(allInZone).every(cb => cb.checked);
        }
    });
}

export default initCommunesSelection;
